import { IPurchaseContractResponse, IPurchaseContractDetailResponse } from "../../../model/base/response/purchase-contract-response";
import { IPurchaseContractFileResponse } from "../../../model/base/response/purchase-contract-file-response";
import { Pagination } from "../../../model/paginatiion";

export type PurchaseContractsState = {
    purchaseContracts: Pagination<IPurchaseContractResponse>;
    contractDetail: IPurchaseContractDetailResponse | null;
    contractFiles: IPurchaseContractFileResponse[];
};

export enum ACTION_TYPES {
    SET_PURCHASE_CONTRACTS = 'SET_PURCHASE_CONTRACTS',
    CLEAR_PURCHASE_CONTRACTS = 'CLEAR_PURCHASE_CONTRACTS',
    SET_CONTRACT_DETAIL = 'SET_CONTRACT_DETAIL',
    SET_CONTRACT_FILES = 'SET_CONTRACT_FILES',
}

export const initialState: PurchaseContractsState = {
    purchaseContracts: new Pagination<IPurchaseContractResponse>(),
    contractDetail: null,
    contractFiles: []
};

export const PurchaseContractsReducer = (state: PurchaseContractsState, action: any): PurchaseContractsState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.SET_PURCHASE_CONTRACTS:
            return {
                ...state,
                purchaseContracts: payload,
            };
        case ACTION_TYPES.CLEAR_PURCHASE_CONTRACTS:
            return {
                ...state,
                purchaseContracts: new Pagination<IPurchaseContractResponse>(),
            };
        case ACTION_TYPES.SET_CONTRACT_DETAIL:
            return {
                ...state,
                contractDetail: payload,
            };
        case ACTION_TYPES.SET_CONTRACT_FILES:
            return {
                ...state,
                contractFiles: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
